import { getWithAuth } from "utilities/api";

export async function getStatistics(accessToken: string, query: string, signal: AbortSignal | null = null) {
  var url = window.env.baseURL + "metrices/" + query;
  return getWithAuth(url, accessToken, signal).then((response) => {
    return response;
  });
}

export async function getRecentStatistics(accessToken: string, query: string, signal: AbortSignal | null = null) {
  var url = window.env.baseURL + "metrices/recent" + query;
  return getWithAuth(url, accessToken, signal).then((response) => {
    return response;
  });
}

export async function getUserCount(accessToken: string) {
  var url = window.env.baseURL + "metrices/userCount";
  return getWithAuth(url, accessToken).then((response) => {
    return response;
  });
}

export async function getApplicationCount(accessToken: string) {
  var url = window.env.baseURL + "metrices/applicationCount";
  return getWithAuth(url, accessToken).then((response) => {
    return response;
  });
}

export async function getCrashChartData(accessToken: string, query: string, signal: AbortSignal | null = null) {
  var url = window.env.baseURL + "metrices/CrashStatistics" + query;
  return getWithAuth(url, accessToken, signal).then((response) => {
    return response;
  });
}

export async function getWarningApplicationChartData(accessToken: string, query: string, signal: AbortSignal | null = null) {
  var url = window.env.baseURL + "metrices/WarningApplicationStatistics" + query;
  return getWithAuth(url, accessToken, signal).then((response) => {
    return response;
  });
}
